import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Message, MessageClass } from './Message';

export interface Props {
  message: string;
  title?: string;
}

const Success = (props: Props): JSX.Element => {
  const { message } = props;
  const { title } = props;
  return (
    <Message message={message} messageClass={MessageClass.SUCCESS} icon={faCheck} title={title} />
  );
};

export default Success;
